import { useState } from 'react'
import { Section, SectionHeading } from '../ui/Section'
import { RevealGroup, RevealItem } from '../ui/Reveal'
import BottomSheet from '../ui/BottomSheet'
import { api } from '../../lib/api'
import { useApi } from '../../lib/useApi'

const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : ''

export default function News() {
  const articles = useApi(api.news, [])
  const [open, setOpen] = useState(null) // full article (fetched by slug)

  const read = async (slug) => {
    try {
      const full = await api.article(slug)
      setOpen(full)
    } catch {
      /* ignore */
    }
  }

  if (!articles || articles.length === 0) return null

  return (
    <Section id="news">
      <SectionHeading
        eyebrow="News"
        title="Company and community updates"
        lead="Announcements from OrionDev, and reports from our youth training programmes."
      />

      <RevealGroup each={0.1} className="mt-16 grid gap-x-10 gap-y-14 md:grid-cols-3 xl:gap-x-14">
        {articles.slice(0, 6).map((a) => (
          <RevealItem key={a.id}>
            <button
              onClick={() => read(a.slug)}
              className="group w-full text-left"
            >
              {a.cover_image_url && (
                <div className="aspect-[16/10] w-full overflow-hidden rounded-3xl shadow-[var(--elev-2)] transition-shadow duration-300 group-hover:shadow-[var(--elev-4)]">
                  <img src={a.cover_image_url} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-emphasized group-hover:scale-[1.04]" />
                </div>
              )}
              <p className="mt-5 font-mono text-xs font-semibold text-ink-3">{fmtDate(a.published_at)}</p>
              <h3 className="mt-2 text-xl font-bold leading-tight text-ink transition-colors duration-200 group-hover:text-primary">{a.title}</h3>
              <p className="mt-2 line-clamp-3 text-[15px] leading-relaxed text-ink-3">{a.excerpt}</p>
              <span className="mt-4 inline-block text-sm font-semibold text-primary group-hover:underline">
                Read more →
              </span>
            </button>
          </RevealItem>
        ))}
      </RevealGroup>

      <BottomSheet open={!!open} onClose={() => setOpen(null)} title={open?.title}>
        {open && (
          <article>
            {open.cover_image_url && (
              <img src={open.cover_image_url} alt="" className="mb-5 w-full rounded-2xl object-cover" />
            )}
            <p className="mb-4 font-mono text-xs text-ink-3">{fmtDate(open.published_at)}</p>
            <div className="space-y-4 text-[15px] leading-relaxed text-ink-2">
              {String(open.body || '')
                .split(/\n{2,}/)
                .filter(Boolean)
                .map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
            </div>
          </article>
        )}
      </BottomSheet>
    </Section>
  )
}
